var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "min-h-hero lg:flex lg:flex-col pb-8 lg:pb-7 bg-paint" },
    [
      _c(
        "div",
        { staticClass: "flex-1 flex items-center justify-center px-ogs-large" },
        [
          _c(
            "div",
            { staticClass: "flex flex-col items-center py-28 lg:py-10" },
            [
              _c("div", { staticClass: "max-w-sm text-center space-y-2" }, [
                _c("h1", { staticClass: "text-xl text-theme leading-snug" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.product.title) + "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-theme text-sm md:text-base" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.product.description) +
                      "\n        "
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "px-ogs-large lg:py-7" },
        [
          _c("ProductVariantSelector", {
            staticClass:
              "col-span-12 lg:col-span-8 lg:flex lg:items-end lg:justify-end lg:space-x-10",
            attrs: {
              sizes: _vm.sizes,
              sheens: [],
              "selected-size": _vm.selectedSize,
              "selected-sheen": false,
              "open-above": true,
            },
            on: {
              "change-size": function ($event) {
                _vm.selectedSize = $event
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid grid-cols-12 gap-x-gs gap-y-4 px-ogs-large pt-8 lg:pt-7 lg:border-t lg:border-theme",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "col-start-5 col-span-4 hidden lg:flex items-center justify-center",
            },
            [
              _c(
                "h4",
                {
                  staticClass:
                    "text-theme opacity-70 leading-tight text-center",
                  attrs: { "data-testid": "selected-variant-details" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.product.title) +
                      " / " +
                      _vm._s(_vm.selectedSize.title) +
                      "\n      "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("ProductAddToCartForm", {
            staticClass:
              "col-span-12 lg:col-start-11 lg:col-span-2 flex items-center justify-end space-x-3",
            attrs: { variant: _vm.variant, loading: _vm.isLoading },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }